import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import NotFoundStatusContext from "../../../notFoundStatusContext";

const styles = {
  container: {
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "80px 20px",
    fontFamily: "'Poppins', sans-serif",
  },
  code: {
    fontSize: "6rem",
    fontWeight: 700,
    color: "#0162ca",
    lineHeight: 1,
    margin: 0,
  },
  heading: {
    fontSize: "1.75rem",
    fontWeight: 700,
    color: "#0a0a0a",
    margin: "16px 0 12px",
  },
  message: {
    fontSize: "1rem",
    color: "#454545",
    maxWidth: "480px",
    marginBottom: "30px",
    lineHeight: 1.6,
  },
  button: {
    display: "inline-block",
    fontFamily: "'Poppins', sans-serif",
    fontSize: "16px",
    fontWeight: 500,
    color: "#ffffff",
    background: "linear-gradient(112.11deg, #03228f 0%, #0b70e1 77%)",
    padding: "14px 32px",
    borderRadius: "3px",
    textDecoration: "none",
  },
};

function NotFound() {
  const { setIsNotFoundRoute } = useContext(NotFoundStatusContext);

  useEffect(() => {
    setIsNotFoundRoute(true);
    return () => setIsNotFoundRoute(false);
  }, [setIsNotFoundRoute]);

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Page Not Found | 360 SynergyTech</title>
        <meta name="robots" content="noindex, follow" />
        <meta property="og:title" content="Page Not Found | 360 SynergyTech" />
        <meta name="twitter:title" content="Page Not Found | 360 SynergyTech" />
      </Helmet>
      <p style={styles.code}>404</p>
      <h1 style={styles.heading}>Page Not Found</h1>
      <p style={styles.message}>
        Sorry, the page you're looking for doesn't exist or may have been moved.
        Please check the URL or return to the homepage.
      </p>
      <Link to="/" style={styles.button}>
        Back to Homepage
      </Link>
    </div>
  );
}

export default NotFound;
